<script>
	const config = require('core/config');
	const request = require('superagent');
	const { clear } = require('model/stores/indexedDbStore');
	const { disableOfflineMode, getOfflineModeStatus, clearAll } = require('utilities/offlineUtilities');

	const ASSET_HOST = config.resources.assets.cdn || config.resources.assets.origin;
	module.exports = {
		modelData: ['offlineMode', 'offlineAssignments', 'offlineModeAvailable'],
		data: function () {
			return {
				error: null,
				result: [],
				showAssignmentData: false,
				offlineStatus: {},
				serviceWorkerRegistered: false
			};
		},

		methods: {
			onDisableOfflineClick() {
				disableOfflineMode();
			},

			unregisterServiceWorker() {
				if ('serviceWorker' in navigator) {
					navigator.serviceWorker.ready.then(s => s && s.unregister());
				}
			},

			clearIDB() {
				clear();
			},

			clearAllOffline() {
				clearAll();
			}
		},

		mounted() {
			var r = request.post('/v2/admin/diagnostic');

			r.set('x-auth', 'diagnosticXAuth');
			r.set('x-rw-version', 'diagnosticXVersion');

			var self = this;

			r.end(function (error, response) {
				if (error) {
					self.error = error;
				} else {
					self.result.push.apply(self.result, [
						{
							check: 'Auth (outbound)',
							pass: response.body.xAuth === 'diagnosticXAuth'
						},
						{
							check: 'Version (outbound)',
							pass: response.body.rwVersion === 'diagnosticXVersion'
						}
					]);
				}
			});

			var cors = request.get(ASSET_HOST + '/assets/dist/styles/main.css');

			cors.set('x-rw-version', void 0);

			cors.end(function (error, response) {
				if (error && !error.crossDomain) {
					self.error = error;
				} else if (error && error.crossDomain) {
					self.result.push({
						check: 'CORS',
						pass: false
					});
				} else {
					self.result.push({
						check: 'CORS',
						pass: true
					});
				}
			});

			getOfflineModeStatus().then(status => (this.offlineStatus = status));

			if ('serviceWorker' in navigator) {
				navigator.serviceWorker.ready.then(s => (this.serviceWorkerRegistered = !!s));
			}
		}
	};
</script>
<template>
	<main
		id="content"
		class="main"
		role="main">
		<div class="main-content wrapper">
			<div class="main-stats">
				<h2>General Stats</h2>
				<div v-if="error">
					<div>Failed!</div>
					<div>{{ error }}</div>
				</div>
				<div
					v-for="entry in result"
					:key="entry.check">
					{{ entry.check }}
					<span
						v-if="entry.pass"
						class="pass"
						>Passed</span
					><span
						v-if="!entry.pass"
						class="fail"
						>Failed</span
					>
				</div>
			</div>
			<div class="offline-stats">
				<h2>Offline Mode Stats</h2>
				<div>Service Worker Registered: {{ serviceWorkerRegistered }}</div>
				<button
					class="button"
					@click="unregisterServiceWorker">
					Unregister Service Worker
				</button>
				<hr />
				<div>Offline Mode Available: {{ offlineModeAvailable }}</div>
				<div>Offline Mode Activated: {{ offlineMode }}</div>
				<div>Offline Timestamp: {{ (offlineStatus.ts / 1000) | date }}, {{ (offlineStatus.ts / 1000) | time }}</div>
				<div>Offline Workspace Edits: {{ offlineStatus.data }}</div>
				<button
					class="button"
					@click="onDisableOfflineClick">
					Disable Offline
				</button>
				<button
					class="button"
					@click="clearIDB">
					Clear IndexedDB
				</button>
				<hr />
				<div>
					<div>Offline Assignments:</div>
					<button
						class="button"
						@click="showAssignmentData = !showAssignmentData">
						Show / Hide Assignment Data
					</button>
					<div
						style="white-space: pre"
						v-show="showAssignmentData">
						{{ offlineAssignments | prettyJson }}
					</div>
				</div>
				<div>
					<hr />
					<button
						class="button -danger"
						@click="clearAllOffline">
						CLEAR ALL - Unregister worker, clear cache, clear IDB
					</button>
				</div>
			</div>
		</div>
	</main>
</template>
<style scoped>
	.pass {
		color: green;
	}

	.fail {
		color: red;
	}
</style>
